<template>
	<div>
        <Modal v-show="showCancelModal" v-on:close="gotToTheCustomerPage()">
            <template>
                <div class="text-center flex flex-column align-center">
                    <span class="margin-bottom font-primary text-wrapper"> Cancel the customer’s subscription?</span>
                    <button :disabled="showLoader" v-on:click="cancelSubscription">Confirm</button>
                </div>                
			</template>
        </Modal>
        <Loader v-show="showLoader" />
	</div>
</template>

<script>    
import Vue from 'vue'

export default {    
    data() {
        return {
            customerId: null,
            showCancelModal: false,
            showLoader: false
        }
    },
    methods: {
        gotToTheCustomerPage() {
            this.$router.push('/customer/' + this.customerId);
        },

        cancelSubscription() {
            this.showCancelModal = false;
            this.showLoader = true; 

            const params = {
                cancel_orders: false,
                feedback: "Cancelled from Zendesk",
                reason: 8
            };
            Vue.api.post(`/zendesk/customers/${this.customerId}/subscription/cancel`, params, {
                callback: (response) => {
                    if (response && response.success) {
                        this.gotToTheCustomerPage();                     
                    } else {
                        this.showCancelModal = false;
                        alert("API call was succesful but the subscription was not cancelled. Check the customer's subscription status and try again if necessary.");
                        this.gotToTheCustomerPage();
                    }
                },
                error: (err) => {
                    console.error("Error cancelling order", err);
                },
                errorMessage: (message) => {
                    if(message === 'Subscription is already cancelled') {
                        this.showCancelModal = false;
                        alert(message);
                        this.gotToTheCustomerPage();
                    } else {
                        alert("Something went wrong: " + message + ". Try again.");
                        this.showCancelModal = true;
                    }
                },
                always: () => {
                   this.showLoader = false;
                }
            });
        },

        getCustomerId() {
            Vue.api.get('/search/customer?term=' + this.$route.params.email, {}, {
                callback: (data) => {
                    if (!data.url) {
                        alert('Customer not found')
                    } else {
                        this.customerId = data.url.split('/')[2];
                        this.showCancelModal = true;
                    }
                },
                error: (err) => {
                    console.error("Error getting customer id", err);
                }
            });
        }
    },
    created() {
        this.getCustomerId();
    }
}
</script>

<style lang="less" scoped>  
.notify-wrapper {
  position: absolute;
  right: 0;
  top: 20px;
  background: rgba(255, 255, 255, 0.6);
  padding: 10px;
  border-radius: 5px;
  z-index: 99;
  flex-direction: column;
}

.text-wrapper{
    font-size: 18px;
    font-weight: 400;
    color: #2b2b2be0;
    text-align: center;
    line-height: 1.5;
    max-width: 400px;
    margin: 0 auto;
    padding-bottom: 30px;
}

::v-deep .modal .modal-content {
    overflow-y: auto;
}
</style>
